var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.purchase.actions.customer.unpublish
        ? _c(
            "b-btn",
            {
              staticClass: "btn-card-action btn-card-action-danger my-1",
              on: {
                click: function ($event) {
                  _vm.showModal = true
                },
              },
            },
            [
              _vm._v(" Снять с публикации"),
              _vm.purchase.can_be_canceled_till
                ? [
                    _c("br"),
                    _vm._v(
                      "(До " +
                        _vm._s(
                          _vm.getDateTimeFormat(
                            _vm.purchase.can_be_canceled_till
                          )
                        ) +
                        ")"
                    ),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _c(
        "b-modal",
        {
          ref: "publish-modal",
          attrs: {
            size: "lg",
            centered: "",
            "hide-header-close": "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            title: "Снять с публикации для редактирования",
          },
          model: {
            value: _vm.showModal,
            callback: function ($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal",
          },
        },
        [
          _c("div", [
            _c("p", [
              _vm._v(
                " Вы действительно хотите снять с публикации для редактирования закупку "
              ),
              _c("strong", [_vm._v(_vm._s(_vm.purchase.reg_number))]),
              _vm._v("? "),
            ]),
            _c("ul", [
              _c("li", [
                _vm._v(
                  "- Снятие извещения с публикации возможно только 1 раз."
                ),
              ]),
              _c("li", [
                _vm._v(
                  "- Снятие извещения с публикации приведет к отмене всех поданных на данное извещение предложений от поставщиков."
                ),
              ]),
              _c("li", [
                _vm._v(
                  '- Снятие извещения с публикации позволит Вам внести изменения в извещение, за исключением поля "Наименование закупочной сессии".'
                ),
              ]),
              _c("li", [
                _vm._v(
                  " - В момент снятия извещения с публикации, будет зафиксировано оставшееся рабочее время до окончания подачи предложений. В момент возобновления публикации, время окончания подачи предложений будет рассчитано на основании зафиксированного в момент снятия извещения с публикации, оставшегося рабочего времени. "
                ),
              ]),
            ]),
            _c("p", [
              _c("strong", [_vm._v("Объект закупки")]),
              _vm._v(": " + _vm._s(_vm.purchase.purchase_object)),
              _c("br"),
              _c("strong", [_vm._v("Предмет закупки")]),
              _vm._v(": " + _vm._s(_vm.purchase.deliverable_group_title)),
              _c("br"),
              _c("strong", [_vm._v("Сумма закупки, руб.")]),
              _vm._v(": " + _vm._s(_vm.$formatPrice(_vm.purchase.start_price))),
              _c("br"),
              _c("strong", [_vm._v("Планируемая дата заключения договора")]),
              _vm._v(
                ": " +
                  _vm._s(
                    _vm.getDateFormat(
                      _vm.purchase.planned_contract_conclusion_date
                    )
                  ) +
                  " "
              ),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass: "w-100 text-right",
              attrs: { slot: "modal-footer" },
              slot: "modal-footer",
            },
            [
              _c(
                "b-overlay",
                {
                  staticClass: "d-inline-block",
                  attrs: {
                    show: _vm.isLoading,
                    opacity: "0.6",
                    rounded: "",
                    "spinner-small": "",
                    "spinner-variant": "primary",
                  },
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "text-uppercase mr-2",
                      attrs: { variant: "custom-outline-secondary" },
                      on: {
                        click: function ($event) {
                          _vm.showModal = false
                        },
                      },
                    },
                    [_vm._v("Отмена")]
                  ),
                  _vm._v("  "),
                ],
                1
              ),
              _c(
                "b-overlay",
                {
                  staticClass: "d-inline-block",
                  attrs: {
                    show: _vm.isLoading,
                    opacity: "0.6",
                    rounded: "",
                    "spinner-small": "",
                    "spinner-variant": "primary",
                  },
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "text-uppercase",
                      attrs: { variant: "custom-danger" },
                      on: { click: _vm.unpublishPurchase },
                    },
                    [_vm._v("Снять с публикации")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }